import ChatbotPlayer from './ChatbotPlayer'
export default ChatbotPlayer
